import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../Icon';

export default function StatusSpan(props) {
    return (
        <span className="appActions-status">
            <Icon alias="check" /> {props.text}
        </span>
    );
}

StatusSpan.propTypes = {
    text: PropTypes.string.isRequired,
    borderNone: PropTypes.bool,
};
